import React, { useEffect } from 'react'
import { replaceUrl } from 'libraries/front-end-core/core/history'
import Account from 'pages/account/Account'
import { useSelector } from 'react-redux'
import selectIsLogged from 'redux/selectors/selectIsLogged'

const AccountPageWrapper = (props) => {
  const isLogged = useSelector(selectIsLogged)

  useEffect(() => {
    if (!isLogged) {
      replaceUrl('/')
    }
  }, [isLogged])

  return <Account {...props} />
}

export default AccountPageWrapper
